import {writable} from 'svelte/store'
import type {Component} from 'svelte'

type Modal = {
  component: Component<any>,
  transitionIn?: string,
  props: any
}

function modalStore() {
  const {subscribe, set} = writable<Modal | null>(null)

  const show = (component: Modal['component'], params: Partial<Omit<Modal, 'component'>> = {}) => {
    set({component, props: {}, ...params})
  }

  const close = () => set(null)

  return {
    subscribe,
    close,
    show
  }
}

export const modal = modalStore()
